import React from 'react';
import RadioSection from '../../Sections/RadioSection';
import Address2 from '../Address2';
const DuplexSecondMeter = (p) => {  
    return (
        <div>
            <Address2 name="duplexSecondAddress" title={window.osa.lookup.serviceAddress.duplexSecondAddressTitle}
                address={p.address} />
            <RadioSection name="duplexSecondMeterLocation" {...window.osa.lookup.serviceAddress.duplexSecondMeterLocation} />
        </div>
    );
};

export default DuplexSecondMeter;